import { IconCircleCheck } from '@tabler/icons-react';
import { IconBowlChopsticksFilled } from '@tabler/icons-react';
import AceptarPedidoButton from '../Utils/AceptarPedidoButton';
import CancelarPedidoButton from '../Utils/CancelarPedidoButton';
import CerrarPedidoButton from '../Utils/CerrarPedidoButton';
import CobrarPedidoButton from '../Utils/CobrarPedidoButton';
import DetallesWhite from '../Utils/DetallesWhite';
import PedidoTiempo from '../Utils/PedidoTiempo';

const FONT = '"Public Sans", sans-serif';

export default function TarjetaPedidos({
  nombre,
  fecha,
  hora,
  dia,
  unidades,
  section,
  startTime,
  isClosing,
  requiresPayment,
  onCancelar,
  onVerDetalles,
  onCerrarPedido,
  onAceptarPedido,
  onCobrar,
}) {
  const isReady = section === 'ready';
  const isInProgress = section === 'in_progress';
  const isPending = section === 'pending';
  const meta = [dia, fecha, hora].filter(Boolean).join(' · ');

  return (
    <div
      className="relative flex flex-col gap-4 rounded-2xl p-4 lg:p-5"
      style={{
        backgroundColor: '#141414',
        boxShadow: '0 12px 32px rgba(0, 0, 0, 0.28)',
        fontFamily: FONT,
      }}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex flex-col gap-1 min-w-0">
          <h3
            className="font-semibold m-0 truncate"
            style={{
              fontSize: '16px',
              lineHeight: '21px',
              letterSpacing: '-0.01em',
              color: 'rgba(255, 255, 255, 0.95)',
            }}
            title={nombre}
          >
            {nombre}
          </h3>
          {meta && (
            <p
              className="m-0 truncate"
              style={{
                fontSize: '13px',
                lineHeight: '18px',
                fontWeight: 500,
                color: 'rgba(255, 255, 255, 0.45)',
                fontVariantNumeric: 'tabular-nums',
              }}
            >
              {meta}
            </p>
          )}
        </div>

        {isInProgress && startTime && (
          <div className="shrink-0 -mt-1 -mr-1">
            <PedidoTiempo startTime={startTime} icon={IconBowlChopsticksFilled} />
          </div>
        )}

        {isReady && (
          <span
            className="inline-flex items-center gap-1.5 shrink-0 h-7"
            style={{ fontSize: '13px', fontWeight: 600, color: '#30d158' }}
          >
            <IconCircleCheck size={18} stroke={2} />
            Completado
          </span>
        )}
      </div>

      {unidades != null && (
        <span
          className="inline-flex items-center self-start h-8 rounded-full px-3"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            fontSize: '13px',
            fontWeight: 500,
            color: 'rgba(255, 255, 255, 0.55)',
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          {unidades} {Number(unidades) === 1 ? 'producto' : 'productos'}
        </span>
      )}

      <div className="flex items-center gap-2 min-w-0">
        <DetallesWhite onClick={onVerDetalles} grow={isReady} />
        {!isReady && (
          <>
            {isPending ? (
              <AceptarPedidoButton onClick={onAceptarPedido} />
            ) : requiresPayment ? (
              <CobrarPedidoButton onClick={onCobrar} />
            ) : (
              <CerrarPedidoButton onClick={onCerrarPedido} loading={isClosing} />
            )}
            <CancelarPedidoButton onClick={onCancelar} />
          </>
        )}
      </div>
    </div>
  );
}
